import Image from 'next/image';
import VerticalLine from '../VerticalLine';
import { SidebarNav } from './SidebarNav';
import * as S from './styles';

export function Sidebar() {
  return (
    <S.AsideContainer>
      <S.LogoContainer>
        <Image src="/images/nextOED.svg" width={92} height={31} />
        <VerticalLine margin="0 10px" height="80%" />
        <Image src="/images/dorina.svg" width={63} height={32} />
      </S.LogoContainer>

      <SidebarNav />
    </S.AsideContainer>
  );
}
